import React, { Component } from "react";

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// actions
import { loginUser, apiError } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.jpg";
import logox from "../../assets/images/shanti jewwllers png logo.PNG";

import Notiflix from "notiflix";
import PostApiCall from "../../Api";
// import GetApiCall from '../../GetApi';
import moment from "moment";

import OtpInput from "react-otp-input";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";

import "./Login.css";

var otp = Math.floor(100000 + Math.random() * 900000);

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPasswordVisible: false,
      DecimalRegex: /^(\d*\.?\d{0,2}|\.\d{0,9})$/,
      NumRegex: /^[0-9]*$/,
      AlphaNumericRegex: /^[a-zA-Z0-9]*$/,
      EmailRegex:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      UrlRegex:
        /^(https:\/\/www\.|httpss:\/\/www\.|https:\/\/|httpss:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,

      Email: "",
      Password: "",

      open: false,
      EnteredOtp: "",
      MailerOtp: "",
      openOtp: false,
      openPassword: false,
      NewPassword: "",
      ConfirmPassword: "",
      Salt: [],
      isNewPasswordVisible: false,
      isConPasswordVisible: false,
      VerifyEmail: "",

      history: useHistory,
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "#880105",
    });
    localStorage.removeItem("LoginDetail");
    localStorage.removeItem("OTP");
  }

  onClickLogin() {
    if (this.state.Email !== "") {
      if (this.state.EmailRegex.test(this.state.Email)) {
        if (this.state.Password !== "") {
          Notiflix.Loading.Dots("");
          console.log({
            email: this.state.Email,
            password: this.state.Password,
          });

          PostApiCall.postRequest(
            {
              email: this.state.Email,
              password: this.state.Password,
            },
            "New_Admin_Login"
          ).then((results) =>
            // const objs = JSON.parse(result._bodyText)
            results.json().then((obj) => {
              if (results.status === 200 || results.status === 201) {
                // console.log(obj.data[0].fld_usertype)
                if (
                  obj.data[0].fld_usertype === "Customer" ||
                  !obj.data[0].fld_usertype
                ) {
                  localStorage.setItem(
                    "OldPassword",
                    JSON.stringify(this.state.Password)
                  );

                  localStorage.setItem(
                    "lastlogin",
                    JSON.stringify(moment().format("lll"))
                  );

                  localStorage.setItem("LoginDetail", JSON.stringify(obj.data));

                  Notiflix.Loading.Remove();
                  window.location.href = "/dashboard";
                } else if (
                  obj.data[0].fld_usertype === "Employee" ||
                  obj.data[0].fld_usertype === "Admin"
                ) {
                  // console.log('admin')
                  localStorage.setItem(
                    "OldPassword",
                    JSON.stringify(this.state.Password)
                  );

                  localStorage.setItem(
                    "lastlogin",
                    JSON.stringify(moment().format("lll"))
                  );

                  localStorage.setItem("LoginDetail", JSON.stringify(obj.data));

                  Notiflix.Loading.Remove();
                  window.location.href = "/admin_dashboard";
                }
              } else {
                Notiflix.Loading.Remove();
                Notiflix.Notify.Failure(obj.data);
              }
            })
          );
        } else {
          Notiflix.Notify.Failure("Please enter password.");
        }
      } else {
        Notiflix.Notify.Failure("Please enter valid email.");
      }
    } else {
      Notiflix.Notify.Failure("Please enter email.");
    }
  }

  OnChangepwd(password) {
    this.setState({
      Password: password.target.value,
    });
  }

  // =============Get Salt=============

  onPostSalt() {
    Notiflix.Loading.Dots("Please wait...");
    PostApiCall.postRequest(
      {
        email: this.state.VerifyEmail,
      },
      "Get_SaltByEmailId_ForgotPassword"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          this.setState({
            Salt: obj.data,
            openOtp: true,
            open: false,
          });
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure(obj.data);
        }
      })
    );
  }

  onEmailPost = () => {
    Notiflix.Loading.Dots("Please wait...");
    PostApiCall.postRequest(
      {
        OTP: otp,
        email: this.state.VerifyEmail,
      },
      "Mailer_ForgotPassword"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Success(
            "Your verification OTP is successfully sent to your email address.."
          );

          localStorage.setItem("OTP", JSON.stringify(otp));

          this.onPostSalt();
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure("Something went wrong, try again later.");
        }
      })
    );
  };

  SaveEmail() {
    if (this.state.VerifyEmail !== "") {
      if (this.state.EmailRegex.test(this.state.VerifyEmail)) {
        // Notiflix.Loading.Dots('');

        this.onEmailPost();
        // this. onPostSalt()
        // console.log(otp)
      } else {
        Notiflix.Notify.Failure("Please enter valid email address.");
      }
    } else {
      Notiflix.Notify.Failure("Please enter your email address.");
    }
  }

  VerifyOtp() {
    //         console.log(this.state.EnteredOtp )
    //         console.log(JSON.parse(localStorage.getItem('OTP')))
    //    console.log(this.state.EnteredOtp === JSON.parse(localStorage.getItem('OTP'))?'true':'false')
    if (this.state.EnteredOtp !== "") {
      if (this.state.EnteredOtp == JSON.parse(localStorage.getItem("OTP"))) {
        this.setState({
          openPassword: true,
          openOtp: false,
        });
        localStorage.removeItem("OTP");
      } else {
        Notiflix.Notify.Failure("Incorrect OTP.");
      }
    } else {
      Notiflix.Notify.Failure("Please enter OTP.");
    }
  }

  onPostPassword = () => {
    Notiflix.Loading.Dots("Please wait...");

    PostApiCall.postRequest(
      {
        email: this.state.VerifyEmail,
        password: this.state.ConfirmPassword,
        salt: this.state.Salt[0].fld_salt,
        id: this.state.Salt[0].fld_userid,
      },
      "ChangeCustomerPassword"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          Notiflix.Notify.Success("Password Successfully changed");
          window.location.reload();
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure("Something went wrong, try again later.");
        }
      })
    );
  };

  SavePassword() {
    if (this.state.NewPassword !== "") {
      if (this.state.ConfirmPassword !== "") {
        if (this.state.ConfirmPassword === this.state.NewPassword) {
          this.onPostPassword();
        } else {
          Notiflix.Notify.Failure(
            "New Password and Confirm Password do not match "
          );
        }
      } else {
        Notiflix.Notify.Failure("Please enter confirm password.");
      }
    } else {
      Notiflix.Notify.Failure("Please enter new password.");
    }
  }

  render() {
    return (
      <React.Fragment>
        {/* <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-dark"><i className="bx bx-home h2"></i></Link>
                </div> */}
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Modal
              class="modal-content"
              open={this.state.open}
              onClose={() => {
                this.setState({ open: false });
              }}
              center
            >
              <div class="modal-content modelcontent2">
                <div class="modal-header">
                  <h4 class="modal-title recoverPassword">Recover Password</h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Email Address <span class="mandatory">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.VerifyEmail}
                          onChange={(text) => {
                            this.setState({
                              VerifyEmail: text.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    class="btn forgetPassBtn"
                    type="submit"
                    style={{ float: "right" }}
                    onClick={() => {
                      this.setState({
                        open: false,
                      });
                    }}
                  >
                    Close
                  </button>

                  <button
                    class="btn forgetPassBtn"
                    type="submit"
                    style={{ float: "right" }}
                    onClick={this.SaveEmail.bind(this)}
                    data-toggle="modal"
                  >
                    Next
                  </button>
                  <span></span>
                </div>
              </div>
            </Modal>

            {/* Otp============================ */}

            <Modal
              class="modal-content"
              open={this.state.openOtp}
              onClose={() => {
                this.setState({ openOtp: false });
              }}
              center
            >
              <div
                class="modal-content modelcontent2"
                style={{
                  display: this.state.Salt.length != 0 ? "block" : "none",
                }}
              >
                <div class="modal-header">
                  <h4 class="modal-title">Enter Verification Code</h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-3">
                        <OtpInput
                          onChange={(otp) =>
                            this.setState({
                              EnteredOtp: otp,
                            })
                          }
                          value={this.state.EnteredOtp}
                          numInputs={6}
                          separator={<span></span>}
                          inputStyle={{
                            width: "40px",
                            height: 40,
                            margin: "5px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  {/* forgetPassBtn class add by laxmi */}
                  <button
                    // class="btn btn-primary"
                    class="btn forgetPassBtn"
                    type="submit"
                    style={{ float: "right" }}
                    onClick={() => {
                      this.setState({
                        openOtp: false,
                      });
                    }}
                  >
                    Close
                  </button>
                  {/* forgetPassBtn class add by laxmi */}
                  <button
                    class="btn forgetPassBtn"
                    type="submit"
                    style={{ float: "right" }}
                    data-toggle="modal"
                    onClick={this.VerifyOtp.bind(this)}
                  >
                    Next
                  </button>
                  <span></span>
                </div>
              </div>
            </Modal>

            {/* New Password============================ */}

            <Modal
              class="modal-content"
              open={this.state.openPassword}
              onClose={() => {
                this.setState({ openPassword: false });
              }}
              center
            >
              <div class="modal-content modelcontent2">
                <div class="modal-header">
                  <h4 class="modal-title">Change Password</h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          New Password <span class="mandatory">*</span>
                        </label>
                        <input
                          type={
                            this.state.isNewPasswordVisible
                              ? "text"
                              : "password"
                          }
                          class="form-control"
                          value={this.state.NewPassword}
                          onChange={(text) => {
                            this.setState({
                              NewPassword: text.target.value,
                            });
                          }}
                        />
                        <span class="login-icon-change-pass">
                          <i
                            style={{
                              color: this.state.isNewPasswordVisible
                                ? "#000"
                                : "",
                            }}
                            className="fa fa-eye"
                            onClick={() => {
                              this.setState({
                                isNewPasswordVisible:
                                  !this.state.isNewPasswordVisible,
                              });
                            }}
                          />
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Confirm Password <span class="mandatory">*</span>
                        </label>
                        <input
                          type={
                            this.state.isConPasswordVisible
                              ? "text"
                              : "password"
                          }
                          class="form-control"
                          value={this.state.ConfirmPsssword}
                          onChange={(text) => {
                            this.setState({
                              ConfirmPassword: text.target.value,
                            });
                          }}
                        />
                        <span class="login-icon-change-pass">
                          <i
                            style={{
                              color: this.state.isConPasswordVisible
                                ? "#000"
                                : "",
                            }}
                            className="fa fa-eye"
                            onClick={() => {
                              this.setState({
                                isConPasswordVisible:
                                  !this.state.isConPasswordVisible,
                              });
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    class="btn btn-primary"
                    type="submit"
                    style={{ float: "right" }}
                    onClick={() => {
                      this.setState({
                        openPassword: false,
                      });
                    }}
                  >
                    Close
                  </button>

                  <button
                    class="btn btn-primary"
                    type="submit"
                    style={{ float: "right" }}
                    onClick={this.SavePassword.bind(this)}
                  >
                    Save
                  </button>
                  <span></span>
                </div>
              </div>
            </Modal>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="maxXchange-bg-soft-pink">
                    <Row>
                      {/*change by laxmi--------------------------------------------- col size phn view  */}
                      {/* <Col className="col-7"> */}
                      <Col className="col-lg-7 col-md-7 col-sm-7 col-12">
                        <div className="maxXchange-muted-text p-4">
                          <h5 className="maxXchange-muted-text">
                            Welcome Back !
                          </h5>
                          <p>Sign in to continue to Shanthi Jewellers.</p>
                        </div>
                      </Col>

                      {/*change by laxmi--------------------------------------------- col size phn view  */}
                      {/* <Col className="col-5 align-self-end"> */}
                      <Col className="col-lg-5 col-md-5 col-sm-5 col-12 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div className="row">
                      <div className="col-md-6">
                        <Link to="/">
                          <div className="avatar-md profile-user-wid mb-4">
                            <span className="avatar-title rounded-circle bg-light">
                              <img
                                src={logox}
                                alt=""
                                className="rounded-circle"
                                height="80"
                              />
                            </span>
                          </div>
                        </Link>
                      </div>
                      <div className="col-md-6">
                        <Link to="/">
                          <div
                            className="avatar-md profile-user-wid mb-4 d-none d-lg-block"
                            style={{
                              position: "absolute",
                              left: "97px",
                              top: "33px",
                            }}
                          >
                            <img src={logo} alt="" height="34" />
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="p-2">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={this.handleValidSubmit}
                      >
                        <div className="form-group">
                          <div className="form-group">
                            <label for="email">Email</label>
                            <input
                              value={this.state.Email}
                              onChange={(text) => {
                                this.setState({
                                  Email: text.target.value,
                                });
                              }}
                              type="mobile"
                              className="form-control"
                            />
                          </div>
                          <div className="form-group">
                            <label for="pwd">Password:</label>
                            <input
                              value={this.state.Password}
                              type={
                                this.state.isPasswordVisible
                                  ? "text"
                                  : "password"
                              }
                              onChange={this.OnChangepwd.bind(this)}
                              className="form-control"
                            />
                            <span class="login-icon-change-pass">
                              {/* <i class="icon-dual" data-feather="lock"></i>*/}
                              <i
                                style={{
                                  color: this.state.isPasswordVisible
                                    ? "#ab3d00"
                                    : "",
                                }}
                                className="fa fa-eye"
                                onClick={() => {
                                  this.setState({
                                    isPasswordVisible:
                                      !this.state.isPasswordVisible,
                                  });
                                }}
                              />
                            </span>
                          </div>
                          {/* <div className="form-group form-check">
                                                    <label className="form-check-label">
                                                    <input className="form-check-input" type="checkbox"/> Remember me
                                                    </label>
                                                </div>
                                                <div className="mt-3">
                                                    <button className="btn maxXchange-btn btn-block waves-effect waves-light" type="submit">Log In</button>
                                                </div> */}
                        </div>

                        {/* <div className="form-group">
                                                    <AvField name="password" label="Password" value="123456" type="password" validate={{
            required: {value: true, errorMessage: 'Please enter a password'},
            pattern: {value: '^[A-Za-z0-9]+$', errorMessage: 'Your password must be composed only with letter and numbers'},
            minLength: {value: 6, errorMessage: 'Your password must be extact 6 characters'},
            maxLength: {value: 6, errorMessage: 'Your password must be extact 6 characters'}
          }} placeholder="Enter Password" />
                                                </div> */}

                        {/* <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id="customControlInline" />
                                                    <label className="custom-control-label" htmlFor="customControlInline">Remember me</label>
                                                </div> */}

                        <div className="mt-3">
                          <button
                            className="btn maxXchange-btn btn-block waves-effect waves-light"
                            type="submit"
                            onClick={this.onClickLogin.bind(this)}
                          >
                            Log In
                          </button>
                        </div>

                        <div className="mt-4 text-center">
                          <a
                            className="text-muted"
                            onClick={() => {
                              this.setState({
                                open: true,
                              });
                            }}
                          >
                            <i className="mdi mdi-lock mr-1"></i> Forgot your
                            password?
                          </a>
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  {/* <p>Don't have an account ? <Link to="register" className="font-weight-medium maxXchange-text"> Signup now </Link> </p> */}
                  <p>
                    © {new Date().getFullYear()} Shanthi Jewellers. Powered{" "}
                    <i className="mdi mdi-heart text-danger"></i> by Global
                    Trendz
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStatetoProps, { loginUser, apiError })(Login)
);
